import { Link } from "react-router-dom";
import { QrCode } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-zinc-200/80 bg-white" data-testid="footer-navigation">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-12">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-8">
          <div className="flex items-center gap-2.5" data-testid="footer-logo">
            <span className="h-8 w-8 rounded-lg bg-zinc-900 text-white flex items-center justify-center">
              <QrCode size={15} />
            </span>
            <span className="font-heading font-bold tracking-tight">Asset Passport</span>
          </div>
          <nav className="flex flex-wrap items-center gap-x-7 gap-y-3 text-sm text-zinc-500">
            <a href="/#producto" className="hover:text-zinc-900 transition-colors">Producto</a>
            <a href="/#como-funciona" className="hover:text-zinc-900 transition-colors">Cómo funciona</a>
            <a href="mailto:hello@assetpassport.io" className="hover:text-zinc-900 transition-colors">Contacto</a>
            <Link to="/security" data-testid="footer-link-security" className="hover:text-zinc-900 transition-colors">Seguridad</Link>
            <Link to="/legal" data-testid="footer-link-legal" className="hover:text-zinc-900 transition-colors">Aviso legal</Link>
            <Link to="/privacy" data-testid="footer-link-privacy" className="hover:text-zinc-900 transition-colors">Privacidad</Link>
            <Link to="/cookies" data-testid="footer-link-cookies" className="hover:text-zinc-900 transition-colors">Cookies</Link>
            <Link to="/terms" data-testid="footer-link-terms" className="hover:text-zinc-900 transition-colors">Términos</Link>
            <Link to="/dpa" data-testid="footer-link-dpa" className="hover:text-zinc-900 transition-colors">Protección de datos (DPA)</Link>
            <Link to="/login" data-testid="footer-link-login" className="hover:text-zinc-900 transition-colors">
              Iniciar sesión
            </Link>
          </nav>
        </div>
        <p className="text-xs text-zinc-400 mt-10">
          © {new Date().getFullYear()} Asset Passport. La identidad digital de cada máquina.
        </p>
      </div>
    </footer>
  );
}
